/**
 * Keeps the bundle selector (Section Store "block-bundle" app block) visually in
 * sync with the theme's variant selector: the selected bundle gets the same 7px
 * black bar along its bottom edge as a checked variant button
 * (see `.variant-option__button-label:has(:checked)` in base.css).
 *
 * The app block renders its options inside an open shadow root, so theme CSS
 * cannot reach it. The rule is injected into that shadow root instead.
 */
(function () {
  const BLOCK_TAG = 'section-store--bundle-block';
  const STYLE_ID = 'ram-bundle-selected-underline';
  const RETRY_INTERVAL = 200;
  const RETRY_TIMEOUT = 10000;

  /* The app draws the selected option's border on a `::before` overlay, so
     thickening it changes no layout and keeps the options aligned. */
  const CSS = `
    .bundle-option-input:checked ~ .bundle-option-radio-label .bundle-option-box::before {
      border-bottom-width: 7px !important;
      border-bottom-style: solid !important;
      border-bottom-color: #000 !important;
    }
  `;

  function inject(block) {
    const root = block.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function watch(block) {
    if (!block.shadowRoot) return;

    inject(block);

    /* The block rewrites its shadow root when it (re)renders, which drops the
       injected style, so put it back whenever that happens. */
    if (block.dataset.ramUnderlineObserved) return;
    block.dataset.ramUnderlineObserved = 'true';
    new MutationObserver(() => inject(block)).observe(block.shadowRoot, { childList: true });
  }

  function scan() {
    document.querySelectorAll(BLOCK_TAG).forEach(watch);
  }

  function start() {
    scan();

    /* Blocks can be added later by section rendering or the theme editor. */
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

    /* The custom element attaches its shadow root on upgrade, which is not a DOM
       mutation, so poll briefly until the app's script has run. */
    const startedAt = Date.now();
    const timer = setInterval(() => {
      scan();

      const blocks = document.querySelectorAll(BLOCK_TAG);
      const ready = blocks.length > 0 && [...blocks].every((block) => block.shadowRoot?.getElementById(STYLE_ID));

      if (ready || Date.now() - startedAt > RETRY_TIMEOUT) clearInterval(timer);
    }, RETRY_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
